import { useSelector } from 'react-redux';

import { selectPermissions } from 'store/auth/authSlice';

export const usePermissions = pageKey => {
  const permissions = useSelector(selectPermissions);

  const hasPermission = permissions => {
    const isAdminAllow = permissions['web.admin'] === 'allow';

    return isAdminAllow
      ? permissions[pageKey] !== 'disallow'
      : permissions[pageKey] === 'allow';
  };

  const havePermissionToSeePage = hasPermission(permissions);

  const filterRoutesByPermissions = routes => {
    if (!Object.keys(permissions).length) {
      return null;
    }

    const isAdminAllowed = permissions['web.admin'] === 'allow';

    const filterRecursive = node => {
      const routePermission = node.permission;
      const isAllowed = isAdminAllowed
        ? permissions[routePermission] !== 'disallow'
        : permissions[routePermission] === 'allow';

      if (!isAllowed) return null;

      const filteredChildren = node.children
        ? node.children.map(filterRecursive).filter(child => child !== null)
        : null;

      return {
        ...node,
        children: filteredChildren
      };
    };

    return routes.map(filterRecursive).filter(route => route !== null);
  };

  const filterElementsPermissions = pageKey => {
    const pagePermissions = Object.keys(permissions)
      .filter(key => key.startsWith(pageKey))
      .reduce((result, key) => {
        result[key.replace(`${pageKey}.`, '')] = permissions[key];
        return result;
      }, {});

    return pagePermissions;
  };

  const elementsPermission = filterElementsPermissions(pageKey);

  return {
    havePermissionToSeePage,
    permissions,
    elementsPermission,
    hasPermission,
    filterRoutesByPermissions,
    filterElementsPermissions
  };
};
